import { SectionBenefitsProps } from '@sbercloud/uikit-product-site-section';

import { DocumentationProps, Grid } from './types';

export const getColumnsConfig = (
  grid: DocumentationProps['grid'],
): SectionBenefitsProps['columnsConfig'] => {
  switch (grid) {
    case Grid.ThreeColumns: {
      return {
        desktop: {
          amount: 3,
          minWidth: 374,
        },
        desktopSmall: {
          amount: 3,
          minWidth: 374,
        },
        tablet: {
          amount: 2,
          minWidth: 348,
        },
        mobile: {
          amount: 1,
          minWidth: 320,
        },
      };
    }
    case Grid.TwoColumns:
    default: {
      return {
        desktop: {
          amount: 2,
          minWidth: 474,
        },
        desktopSmall: {
          amount: 2,
          minWidth: 474,
        },
        tablet: {
          amount: 2,
          minWidth: 348,
        },
        mobile: {
          amount: 1,
          minWidth: 320,
        },
      };
    }
  }
};
